import React from 'react';

import styled from 'styled-components';

export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  text-align: center;

  ${Styles.desktop} {
    padding: 2rem 0;
    border-block-end: 1px solid rgb(137, 108, 108, 0.1);

    :last-child {
      border-block-end: none;
    }
  }

  > * {
    flex-basis: ${props => 100 / React.Children.count(props.children)}%;
  }
`;
